import { render } from "./UserWallets.vue?vue&type=template&id=14dac640"
import script from "./UserWallets.vue?vue&type=script&lang=js"
export * from "./UserWallets.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__